import { FC } from "react";
import classNames from "classnames";


import { ArrawRightIcon } from "../../../icons";
import { getPaginationItems } from "./utils/getPaginationItems";
import { PaginationProps } from "./types";

import styles from "./Pagination.module.css";



const Pagination: FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const isPrevDisabled = currentPage <= 1;
  const isNextDisabled = currentPage >= totalPages;
  const items = getPaginationItems(currentPage, totalPages);

  const handlePrev = () => {
    onPageChange(Math.max(1, currentPage - 1));
  };

  const handleNext = () => {
    onPageChange(Math.min(totalPages, currentPage + 1));
  };

  return (
    <nav
      className={styles["pagination"]}
      aria-label="Table pagination"
    >
      <button
        type="button"
        className={styles["pagination__arrow"]}
        onClick={handlePrev}
        disabled={isPrevDisabled}
        aria-label="Previous page"
      >
        <ArrawRightIcon
          className={styles["pagination__arrow_icon_prev"]}
          aria-hidden
        />
      </button>
      <div className={styles["pagination__pages"]}>
        {items.map((item, idx) =>
          item === "ellipsis" ? (
            <span
              key={`ellipsis-${idx}`}
              className={styles["pagination__ellipsis"]}
              aria-hidden
            >
              …
            </span>
          ) : (
            <button
              key={item}
              type="button"
              className={classNames(
                styles["pagination__page"],
                currentPage === item && styles["pagination__page_is_active"]
              )}
              onClick={() => onPageChange(item)}
              disabled={currentPage === item}
              aria-label={`Page ${item}`}
              aria-current={currentPage === item ? "page" : undefined}
            >
              {item}
            </button>
          )
        )}
      </div>
      <button
        type="button"
        className={styles["pagination__arrow"]}
        onClick={handleNext}
        disabled={isNextDisabled}
        aria-label="Next page"
      >
        <ArrawRightIcon
          className={styles["pagination__arrow_icon"]}
          aria-hidden
        />
      </button>
    </nav>
  );
};

export default Pagination;
